import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { post, get } from "helpers/api_helper";
import { PINCODES } from "helpers/url_helper";
import Select from "react-select";
import { showSuccessAlert, showErrorAlert } from "helpers/alert_helper";
import CreatableSelect from "react-select/creatable";

const PincodeForm = ({cb = () => {}}) => {
    const [options, setOptions] = useState([]);
    const [cities, setCities] = useState([]);
    const [formData, setFormData] = useState({
        pincode: '',
        state: '',
        city: '',
    });

    const getPincodeList = async () => {
        const { success, data } = await get(`${PINCODES}/opt`);
        if(success){
            setOptions(data);
        }
    }

    useEffect(() => {
        getPincodeList();
    }, []);

    useEffect(() => {
        const stateId = formData?.state?.value;
        if(stateId){
            const filteredCities = options?.cities?.filter(o => o.parent_id == stateId)
            setCities(filteredCities);
        } else {
            setCities([]);
        }
    }, [formData?.state]);

    const handelSubmit = async (e) => {
        e.preventDefault();
        
        try{
            const { success } = await post(PINCODES, formData);
            if(success){
                showSuccessAlert('Pincode Added successfully', () => {
                    setCities([]);
                    setFormData({
                        state: '',
                        city: '',
                        pincode: '',
                    });
                });
                cb();
            } 
        } catch (error) {
            showErrorAlert(error.message || 'Failed to add pincode');
        }
    };


    return (
        <Row>
            <Col>
                <Card>
                    <CardBody>
                        <h5 className="mb-3"> <i onClick={cb} className="fas fa-arrow-left me-3" role="button" title="Back to All Courier Patners " /> New Pincode</h5>
                        <hr />
                        <form onSubmit={handelSubmit}>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label htmlFor="pincode">New Pincode</label>
                                        <input type="number" className="form-control" id="pincode" name="pincode" onChange={e => setFormData({...formData, pincode: e.target.value})} placeholder="Pincode" required />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="special_rate_pincodes">Select States</label>
                                        <Select
                                            value={formData?.state}
                                            onChange={(e) => setFormData({...formData, state: e})}
                                            options={options?.states}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Branch Admin"
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <div className="form-group">
                                        <label htmlFor="special_rate_pincodes">Select City</label>
                                        {/* <Select
                                            value={formData?.city}
                                            onChange={(e) => setFormData({...formData, city: e})}
                                            options={cities || []}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Branch Admin"
                                        /> */}

                                        <CreatableSelect
                                            value={formData?.city}
                                            onChange={(e) => setFormData({ ...formData, city: e })}
                                            options={cities || []}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select or Add City"
                                            onCreateOption={(inputValue) => {
                                                // create new option object
                                                const newOption = { value: inputValue, label: inputValue };

                                                // update your cities list
                                                setCities((prev) => [...prev, newOption]);

                                                // also update form data
                                                setFormData({ ...formData, city: newOption });
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            
                            <hr />
                            <Row className="text-end">
                                <Col>
                                    <button className="btn btn-danger me-2 " style={{width: '120px'}} type="button" onClick={cb}>Cancel</button>
                                    <button className="btn btn-primary" style={{width: '120px'}} type="submit">Submit</button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                    
                </Card>
            </Col>
        </Row>
    );
}

export default PincodeForm;